import './App.css'
import Home from "./pages/Lhome";
// core styles are required for all packages
import "@mantine/core/styles.css";
import "@ant-design/v5-patch-for-react-19";
import Aboutus from "./pages/About us";
import Contactus from "./pages/Contact us";
import { Route, Routes } from "react-router-dom";
import Boompaydetails from './pages/Boompaydetails';


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        {/* <Route path="/services" element={<Services />} /> */}
        {/* <Route path="/work-details" element={<Worksdetails />} /> */}
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/details-about-boom-pay" element={<Boompaydetails />} />
      </Routes>
    </>
  );
}

export default App;
